export default __webpack_public_path__ + "static/media/404.717bab3c.svg";